import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { take} from 'rxjs/operators';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { GenericModalService} from '../../../../services/generic-modal.service';
import { CheckboxListComponent, ICheckboxListSettings } from '../../../../common/checkbox-list/checkbox-list.component';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-related-business-process-configuration',
  templateUrl: './related-business-process-configuration.component.html',
  styleUrls: ['./related-business-process-configuration.component.css', '../../../../styles/business-process-configuration.css']
})
export class RelatedBusinessProcessConfigurationComponent implements OnInit, OnDestroy {

  @ViewChild(CheckboxListComponent, { static: false }) checkboxListComponent: CheckboxListComponent;

  bpId: string;
  bpName: string;
  bpDescription: string;
  hasConfiguration: boolean;

  inscription: Subscription;

  relatedConfigurationForm: FormGroup;

  successMessage: string;
  errorMessage: string;
  submitClick = false;

  metadatasData = [];
  fieldsData = [];
  fieldsExistingConfig = [];
  metadataExistingConfig = [];
  selectedFields = [];
  selectedMetadata = [];
  selectedBPExistingConfig = [];
  selectedBP = [];
  bp = [];

  fieldListSettings: ICheckboxListSettings;
  metadataListSettings: ICheckboxListSettings;

  constructor(private bpService: BusinessProcessService, private formBuilder: FormBuilder, private route: ActivatedRoute,
              private modalService: GenericModalService) { }

  ngOnInit() {
    this.errorMessage = '';
    this.bpDescription = '';
    this.bpName = '';
    this.inscription = this.route.params.subscribe(params => this.bpId = params['id']);

    if (!isNaN(parseFloat(this.bpId))) {
      this.bpService.loadRelatedBPConfiguration(parseFloat(this.bpId)).subscribe(resp => {
        this.bpDescription = resp.businessProcess.description;
        this.bpName = resp.businessProcess.name;

        // carregar todos os Metadados Participantes
        this.metadatasData = resp.metadataSelections.map(metadataSelection => metadataSelection.metadataStructure);
        this.metadataExistingConfig = resp.metadataSelections.filter(f => f.isKey === true)
          .map( f => f.metadataStructure.metadataStructureId);
        this.setMetadataListSettings();
        this.selectedMetadata = this.metadataExistingConfig;

        // carregar todos os Campos Participantes
        this.fieldsData = resp.fieldSelections.map(fieldSelection => fieldSelection.field);
        this.fieldsExistingConfig = resp.fieldSelections.filter(f => f.isViewField === true)
          .map(f => f.field.fieldId);
        this.setFieldListSettings();
        this.selectedFields = this.fieldsExistingConfig;

        // inicio - carregar os Processos de Negócios
        this.bp = resp.allBusinessProcesses.map(m => ({ id: m.businessProcessId, label: m.name }));
        this.selectedBPExistingConfig = resp.relatedBusinessProcesses.map(m => m.businessProcessId );
        this.selectedBP = this.selectedBPExistingConfig;
        // fim - carregar os Processos de Negócios

        this.hasConfiguration = resp.hasConfiguration;
      }, error => {
        this.errorMessage = error;
        console.error(error);
      });
    } else {
      this.errorMessage = 'Erro: Não foi possível recuperar as informações para o valor informado.';
    }
    this.createForm();
  }

  createForm() {
    this.relatedConfigurationForm = this.formBuilder.group({
      businessProcessScope: [ [] ],
    });
  }

  onSave() {
    this.submitClick = true;
    this.errorMessage = '';

    // const selectedBp = this.relatedConfigurationForm.value.businessProcessScope;
    const relatedBp = this.selectedBP; // selectedBp.map(m => m.id);
    if (relatedBp === undefined || relatedBp.length === 0) {
      let message = 'Nenhum processo de negócio foi relacionado.';
      message += ` A busca irá considerar apenas instâncias do processo de negócio <b>${this.bpName}</b>.`;
      message += '<br> Continuar?';

      const alert = this.modalService
        .showConfirmModal('Aviso', message);
      alert.then((result) => {
        if (result.value) {
          this.hasConfiguration = true;
          this.save(relatedBp);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.submitClick = false;
        }
      });
    } else {
      this.hasConfiguration = true;
      this.save(relatedBp);
    }
  }

  save(relatedBp) {
    this.bpService.saveRelatedBPConfiguration(parseFloat(
        this.bpId), relatedBp, this.selectedMetadata, this.selectedFields, this.hasConfiguration)
      .pipe(take(1))
      .subscribe( resp => {
        this.submitClick = true;
        this.successMessage = this.hasConfiguration ?
          'Configuração atualizada com sucesso.' : 'Configuração criada com sucesso.';
        setTimeout(() => { this.submitClick = false; this.successMessage = ''; }, 2500);
      }, error1 => {
        this.errorMessage = error1;
        this.submitClick = false;
      });
  }

  deleteConfig() {
    this.errorMessage = '';
    this.bpService.deleteRelatedBPConfiguration(parseFloat(this.bpId))
      .subscribe( success => {
        this.submitClick = true;
        this.successMessage = 'Configuração excluída com sucesso.';
        this.hasConfiguration = false;

        setTimeout(() => {
          this.submitClick = false;
          this.successMessage = '';
          this.ngOnInit();
        }, 2500);
      }, error => {
        this.errorMessage = error;
        this.submitClick = false;
      });
  }

  ngOnDestroy() {
    this.inscription.unsubscribe();
  }

  setFieldListSettings() {
    this.fieldListSettings = {
      height: 250,
      idPropertyName: 'fieldId',
      namePropertyName: 'name',
      listTitle: 'Campos Participantes',
      inputSearchId: 'inputSearchFields',
      listOf: 'field'
    };
  }

  getSelectedFields(element) {
    this.selectedFields = element;
  }

  setMetadataListSettings() {
    this.metadataListSettings = {
      height: 250,
      idPropertyName: 'metadataStructureId',
      namePropertyName: 'name',
      listTitle: 'Metadados Participantes',
      inputSearchId: 'inputSearchMetadata',
      checkboxClass: 'ckbKey',
      listOf: 'metadata'
    };
  }

  getSelectedMetadata(element) {
    this.selectedMetadata = element;
  }

  getSelectedBP(element) {
    this.selectedBP = element;
  }

}
